import { useMemo } from 'react'; 
import { expenseFormFields } from '../pages/expenses/expense.config';
import { expenseApi } from '../api/accountsApi'; 
import ExcelUploadManager from './excelUpload/ExcelUploadManager';

const ExpenseExcelUpload = () => {
  const moduleConfig = useMemo(() => ({
    fieldConfig: expenseFormFields.filter((field) => field.name !== 'category'),
    title: 'Expenses',
    saveApi: expenseApi.batchCreate || (async (rows: any[]) => {
      // Fallback if batchCreate is not available
      console.warn('Batch create not available, using individual create');
      const results = [];
      for (const row of rows) {
        try {
          const result = await expenseApi.create(row);
          results.push(result);
        } catch (error) {
          console.error('Failed to create expense:', error);
          results.push({ error: 'Failed to create' });
        }
      }
      return { failedRows: [] };
    }),
  }), []);

  return (
    <ExcelUploadManager
      moduleTitle={moduleConfig.title}
      fieldConfig={moduleConfig.fieldConfig}
      saveApi={moduleConfig.saveApi}
    />
  );
};

export default ExpenseExcelUpload;

